import { useMemo } from "react";

import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { shouldHideBarcodedProducts } from "~/utils/tills/should-hide-barcoded-products";

import { REWARDS_CATEGORY_ID } from "../types";

import { useKioskActiveCategory } from "./use-kiosk-active-category";
import { useKioskProducts } from "./use-kiosk-products";
import { type KioskDisplayProductList } from "./use-kiosk-products/types";

export const useKioskDisplayProducts = (): KioskDisplayProductList[] => {
  const { data: shouldHideBarcoded } = useCurrentTill(
    shouldHideBarcodedProducts
  );
  const { productsList, productsRedeemable } = useKioskProducts();
  const activeCategory = useKioskActiveCategory();

  return useMemo(() => {
    if (!activeCategory?.id) {
      if (shouldHideBarcoded) {
        return productsList.filter(
          (product) => product.product.barcodeIds.length === 0
        );
      }
      return productsList;
    }

    if (activeCategory.id === REWARDS_CATEGORY_ID) {
      return productsRedeemable;
    }

    return productsList.filter((product) => {
      if (shouldHideBarcoded && product.product.barcodeIds.length > 0) {
        return false;
      }
      return product.product.categoryId === activeCategory.id;
    });
  }, [
    productsList,
    productsRedeemable,
    activeCategory?.id,
    shouldHideBarcoded
  ]);
};
